import { isDocker } from "#imports";

export const getCmsBaseUrl = () => {
  let apiBaseUrl = "/";

  if ( isDocker() && import.meta.server ) {
    apiBaseUrl = "http://cms:8080/";
  } else if ( import.meta.dev && import.meta.server ) {
    // TODO: Only set this base url if the proxy is disabled
    apiBaseUrl = "http://localhost:5000/";
  }

  return apiBaseUrl;
};
